export const ADD_IS_LOADED = 'AUTHOR:ADD_IS_LOADED';
export const ADD_AUTHOR = 'AUTHOR:ADD_AUTHOR_INFO';
export const ADD_ERROR = 'AUTHOR:ADD_ERROR';
export const CLEAR_AUTHOR_DATA = 'AUTHOR:CLEAR_AUTHOR_DATA';
